import styled from 'styled-components';

export const Subtitle = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 4px;
`;
